import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
const RolesContext = React.createContext({ roles: [], workEmail: "" });

const PermissionGate = ({ children }) => {
  const [permissions, setPermissions] = useState({});

  const { items } = permissions || {};

  const { rolePermissions, tenant } = items || {};

  //api call

  useEffect(() => {
    if (sessionStorage.getItem("token") ?? localStorage.getItem("token") !== null) {
      axios
        .get(
          `${window._env_.BASE_URL}/services/app/Session/GetCurrentLoginInformations`
        )
        .then((items) => {
          setPermissions({
            items: items.data.result,
          });
        });
    }
  }, []);

  return (
    <RolesContext.Provider
      value={{
        roles: rolePermissions?.grantedPermissionNames,
        workEmail: tenant?.workEmail,
      }}
    >
      {children}
    </RolesContext.Provider>
  );
};

export function useRoles() {
  const context = React.useContext(RolesContext);
  if (context === undefined) {
    throw new Error("useRoles must be used within an RolesProvider");
  }
  return context;
}

export default PermissionGate;
